import { render, staticRenderFns } from "./IdentifierColumn.vue?vue&type=template&id=5f23d483&"
import script from "./IdentifierColumn.vue?vue&type=script&lang=ts&"
export * from "./IdentifierColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports